import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  ColorInput,
  Text,
  Select,
} from "@mantine/core";
import classes from "./edit.module.css";
import { RowDataBanner } from "./types";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto } from "@tabler/icons-react";

interface EditBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEditBanner: (editedBannerData: RowDataBanner) => void;
  bannerData: RowDataBanner;
}

const EditBannerModal: React.FC<EditBannerModalProps> = ({
  isOpen,
  onClose,
  onEditBanner,
  bannerData,
}) => {
  const [editedBanner, setEditedBanner] = useState<RowDataBanner>(bannerData);

  const imageDropzoneRef = useRef<() => void>(null);

  useEffect(() => {
    setEditedBanner(bannerData);
  }, [bannerData]);

  const handleImageUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
      setEditedBanner({ ...editedBanner, imageSrc: file });
    }
  };

  const handleEdit = () => {
    // Perform validation or additional logic as needed
    // Check if any required fields are empty
    if (!editedBanner.title || !editedBanner.imageSrc || !editedBanner.route) {
      alert("Please fill in all the required fields");
      return;
    }
    onEditBanner(editedBanner);
    onClose();
  };

  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Edit Banner
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput
        label="Title"
        required
        maxLength={255}
        mb="sm"
        value={editedBanner.title}
        onChange={(event) =>
          setEditedBanner({ ...editedBanner, title: event.currentTarget.value })
        }
      />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span><span style={{ color: 'red' }}>*</span>
      </Text>
      <Dropzone
        onDrop={handleImageUpload}
        accept={["image/*"]}
        openRef={imageDropzoneRef}
      >
        <div className={classes.imageContainer}>
          {editedBanner.imageSrc ? (
            <img
              src={
                !editedBanner.imageSrc.path
                  ? editedBanner.imageSrc
                  : URL.createObjectURL(editedBanner.imageSrc)
              }
              alt="Image"
              className={classes.imageSize}
            />
          ) : (
            <p>
              <IconPhoto />
            </p>
          )}
        </div>
      </Dropzone>
      <Group>
        <Button
          onClick={() => imageDropzoneRef.current?.()}
          className={classes.imageButton}
        >
          <IconPhoto />
          Upload Image
        </Button>
      </Group>

      {/* <ColorInput
        label="Color"
        placeholder="color"
        mb="sm"
        value={editedBanner.color}
        onChange={(color) => setEditedBanner({ ...editedBanner, color: color })}
      /> */}

        <Select
            label="Route"
            placeholder="Select route"
            required
            defaultValue={'NONE'}
            data={[
                { value: 'NONE', label: 'None' },

                { value: 'ViewnetCash', label: 'ViewnetCash' },
                { value: 'MyQR', label: 'MyQR' },
                { value: 'Rewards', label: 'Rewards' },
                { value: 'Me', label: 'Me' },
                
                { value: 'Membership', label: 'Membership' },
                { value: 'MyVouchers', label: 'MyVouchers' },
                { value: 'MyPurchases', label: 'MyPurchases' },
                { value: 'FAQ', label: 'FAQ' },
                { value: 'TermsOfUse', label: 'TermsOfUse' },
                { value: 'PrivacyPolicy', label: 'PrivacyPolicy' },
                { value: 'PriceList', label: 'PriceList' },
                { value: 'DailyFeed', label: 'DailyFeed' },
                { value: 'MyMerchandise', label: 'MyMerchandise' },

                { value: 'CashHistory', label: 'CashHistory' },
                { value: 'CoinHistory', label: 'CoinHistory' },

                { value: 'Notification', label: 'Notification' },
            ]}
            onChange={(value, option) =>
                setEditedBanner({ ...editedBanner, route: value, websiteRoute: value === 'NONE' ? bannerData.websiteRoute : "" })
            }
            value={editedBanner.route}
        />

        <TextInput
          label="Website Route" 
          placeholder="https://example.com"
          description='Set Route to "None" if specifying a website route.'
          my="sm"
          maxLength={255}
          value={editedBanner.websiteRoute ?? ''} // Value cannot be null, default to empty string
          disabled={editedBanner.route !== 'NONE'} 
          onChange={(event) =>
            setEditedBanner({ ...editedBanner, websiteRoute: event.currentTarget.value })
          }
        />

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonCancel}>
          Back
        </Button>
        <Button onClick={handleEdit} className={classes.buttonSaveChanges}>
          Save Changes
        </Button>
      </Group>
    </Modal>
  );
};

export default EditBannerModal;
